import DesignItem from 'records/DesignItem';
import Base from 'records/Base';

import {
  DESIGN_ITEM_ASYNC_ACTION_START,
  DESIGN_ITEM_ASYNC_ACTION_ERROR,
  DESIGN_ITEM_ASYNC_ACTION_SUCCESS,
  DESIGN_ITEM_ASYNC_ACTION_SUCCESS_WITHOUT_DATA,
  DESIGN_ITEM_UPDATE_ACTION_SUCCESS,
  DESIGN_ITEM_RESET_STATE,
} from 'actions/designItem';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new DesignItem(),
});

const actionsMap = {
  [DESIGN_ITEM_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [DESIGN_ITEM_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [DESIGN_ITEM_ASYNC_ACTION_SUCCESS]: (state, action) => {
    var designItem=new DesignItem(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: designItem,
    });
  },
  [DESIGN_ITEM_ASYNC_ACTION_SUCCESS_WITHOUT_DATA]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [DESIGN_ITEM_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return new Base({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [DESIGN_ITEM_RESET_STATE]: () => {
    return initialState;
  },
};

export default function designItem(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
